import React from "react";
import "../../Assets/Style/style.css";
import "./pagination.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ pagination, getItems }) => {
    if (!pagination) return null;

    const totalPages =
        pagination?.totalPages ??
        Math.ceil(
            (pagination?.totalRecords || 0) /
            (pagination?.pageSize || 1)
        );

    const currentPage = pagination?.currentPage || 1;

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        getItems(page);
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];

        if (totalPages <= 0) return pageNumbers;

        const visiblePages = 4;

        let startPage = Math.max(
            currentPage - Math.floor(visiblePages / 2),
            1
        );

        let endPage = startPage + visiblePages - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(endPage - visiblePages + 1, 1);
        }

        // First page
        if (startPage > 1) {
            pageNumbers.push(
                <div
                    key={1}
                    className={`page ${currentPage === 1 ? "active" : ""}`}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </div>
            );

            if (startPage > 2) {
                pageNumbers.push(
                    <div key="ellipsis-start" className="ellipsis">
                        ...
                    </div>
                );
            }
        }

        // Middle pages
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <div
                    key={i}
                    className={`page ${currentPage === i ? "active" : ""}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </div>
            );
        }

        // Last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(
                    <div key="ellipsis-end" className="ellipsis">
                        ...
                    </div>
                );
            }

            pageNumbers.push(
                <div
                    key={totalPages}
                    className={`page ${
                        currentPage === totalPages ? "active" : ""
                    }`}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </div>
            );
        }

        return pageNumbers;
    };

    const hasPrevious =
        pagination?.hasPrevious ?? currentPage > 1;

    const hasNext =
        pagination?.hasNext ?? currentPage < totalPages;

    return (
        <div className="paginationbrdr border-0 p-0">
            <div className="pagination-container row">
                <div className="col-8">
                    <div className="pagination-controls gap-3 w-50">
                        <button
                            className={`prev ${!hasPrevious ? "disabled" : ""}`}
                            onClick={() =>
                                handlePageChange(currentPage - 1)
                            }
                            disabled={!hasPrevious}
                        >
                            <FaChevronLeft />
                        </button>

                        <div className="page-numbers gap-3">
                            {renderPageNumbers()}
                        </div>

                        <button
                            className={`next ${!hasNext ? "disabled" : ""}`}
                            onClick={() =>
                                handlePageChange(currentPage + 1)
                            }
                            disabled={!hasNext}
                        >
                            <FaChevronRight />
                        </button>
                    </div>
                </div>

                <div className="col-4 end">
                    Total : {pagination?.totalRecords || 0}
                </div>
            </div>
        </div>
    );
};

export default Pagination;